import { FunctionComponent, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import classes from './Vendor.module.scss';

export const Vendor: FunctionComponent = () => {
  const location = useLocation();

  const cdidIOS = new URLSearchParams(location.search).get('cdidIOS') ?? '';

  const cdidAndroid = new URLSearchParams(location.search).get('cdidAndroid') ?? '';

  const appendScript = useCallback((cdid: string) => {
    if (!cdid) {
      return;
    }

    const script = document.createElement('script');
    script.src = `https://delivery.consentmanager.net/delivery/vendorlist.php?cdid=${cdid}&l=automatic`;
    script.type = 'text/javascript';
    script.async = true;
    document.body.appendChild(script);

    return script;
  }, []);

  useEffect(() => {
    const scriptIOS = appendScript(cdidIOS);
    const scriptAndroid = appendScript(cdidAndroid);

    return () => {
      if (scriptIOS) {
        document.body.removeChild(scriptIOS);
      }

      if (scriptAndroid) {
        document.body.removeChild(scriptAndroid);
      }
    };
  }, [appendScript, cdidAndroid, cdidIOS]);

  return (
    <div className={classes['vendor']}>
      {cdidIOS && (
        <div className={classes['vendor__section']}>
          <div className={classes['vendor__section-title']}>IOS</div>
          <div className={`cmpvendorlist${cdidIOS} cmpstyleroot`}></div>
        </div>
      )}
      {cdidAndroid && (
        <div className={classes['vendor__section']}>
          <div className={classes['vendor__section-title']}>Android</div>
          <div className={`cmpvendorlist${cdidAndroid} cmpstyleroot`}></div>
        </div>
      )}
    </div>
  );
};
